import React from "react";
import {
  Computer,
  CookingPot,
  Fingerprint,
  HandCoins,
  Store,
  TruckIcon,
  UserRoundCheck,
  UserRoundCog,
  UserRoundPen,
  Wrench,
} from "lucide-react";
import { Link } from "react-router-dom";

const SelectRole = () => {
  return (
    <div className="login-img">
      <div className="page">
        <div className="">
          <div className="col col-login mx-auto">
            <div className="text-center">
              <img
                src={require("../../../assets/images/brand/logo.png")}
                className="header-brand-img"
                alt=""
              />
            </div>
            <div className="select-role-container">
              <div className="role-white-container">
                <h1 className="text-center role-selection-title">Login As</h1>
                <Link to={`/login/administrator`}>
                  <span class="btn btn-primary role-option">
                    <UserRoundCog size={20} /> CLIENT ADMIN
                  </span>
                </Link>
                <Link to={`/login/pos`}>
                  <span class="btn btn-primary role-option" href="/login/pos">
                    <Computer size={20} /> POS
                  </span>
                </Link>
                <Link to={`/login/coordinator`}>
                  <span class="btn btn-primary role-option">
                    <UserRoundPen size={20} /> COORDINATOR
                  </span>
                </Link>
                <Link to={`/login/accountant`}>
                  <span class="btn btn-primary role-option">
                    <UserRoundCheck size={20} /> ACCOUNTANT
                  </span>
                </Link>
                <Link to={`/login/investor`}>
                  <span class="btn btn-primary role-option">
                    <HandCoins size={20} /> INVESTOR
                  </span>
                </Link>
                <Link to={`/login/kitchen-manager`}>
                  <span class="btn btn-primary role-option">
                    <CookingPot size={20} /> KITCHEN MANAGER
                  </span>
                </Link>
                <Link to={`/login/store-manager`}>
                  <span class="btn btn-primary role-option">
                    <Store size={20} /> STORE MANAGER
                  </span>
                </Link>
                {/* <Link to={`/login/plant-manager`}>
                  <span class="btn btn-primary role-option">
                    <SquareKanban size={20} /> PLANT MANGAER
                  </span>
                </Link> */}
                <Link to={`/login/water-supplier`}>
                  <span class="btn btn-primary role-option">
                    <TruckIcon size={20} /> WATER SUPPLIER
                  </span>
                </Link>
                <Link to={`/login/technician`}>
                  <span class="btn btn-primary role-option">
                    <Wrench size={20} /> TECHNICIAN
                  </span>
                </Link>
                <Link to={`/login/ad-manager`}>
                  <span class="btn btn-primary role-option">
                    <Fingerprint size={20} /> AD MANAGER
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectRole;
